import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
    return (
        <div className="aboutus-page">
            <div className="aboutus-frame">
                <div className="aboutus-hero">
                    <div className="aboutus-hero-copy">
                        <span className="eyebrow">Maison de Haute Couture de l'Être</span>
                        <h1>H'ART ÉLÉGANCE</h1>
                        <p>Nous révélons l'architecture intérieure de la présence. Dans un monde de surface, la véritable élégance naît d'une lecture silencieuse du corps et des émotions.</p>
                        <div className="aboutus-hero-actions">
                            <a className="button button--primary" href="#contact">Entrer en relation avec la Maison</a>
                            <a className="button button--ghost" href="#process">Découvrir la méthode</a>
                        </div>
                    </div>
                    <div className="aboutus-hero-visual">
                        <div className="hero-chip">RÉVÉLATION</div>
                        <div className="hero-panel">
                            <div className="hero-panel-line"></div>
                            <div className="hero-panel-copy">
                                <p>Lecture profonde de l'être</p>
                                <h2>Un art minimaliste, une présence assumée.</h2>
                            </div>
                        </div>
                        <div className="hero-dots">
                            <span></span><span></span><span></span>
                        </div>
                    </div>
                </div>

                <section id="process" className="aboutus-grid">
                    <div className="panel panel--contrast">
                        <span className="panel-label">Philosophie</span>
                        <h2>Lire le corps comme un langage.</h2>
                        <p>Chaque posture, chaque tension, chaque ligne porte une histoire. La Maison H'ART ÉLÉGANCE écoute ces signes pour révéler votre présence authentique.</p>
                    </div>
                    <div className="panel panel--glass">
                        <span className="panel-label">Méthode</span>
                        <h2>Une révélation progressive.</h2>
                        <ul>
                            <li>Analyse de morphologie émotionnelle</li>
                            <li>Décodage des fils émotionnels</li>
                            <li>Alignement de l'architecture intérieure</li>
                        </ul>
                    </div>
                    <div className="panel panel--accent">
                        <span className="panel-label">Valeurs</span>
                        <h2>Discrétion, rigueur, excellence.</h2>
                        <p>La Maison opère dans le silence, avec précision et exigence, pour révéler la plus haute forme de présence.</p>
                    </div>
                </section>

                <section className="aboutus-details">
                    <div className="detail-block">
                        <span className="detail-tag">À propos</span>
                        <h2>H'ART ÉLÉGANCE ne crée pas, elle révèle.</h2>
                        <p>Il ne s'agit pas de transformation. Il s'agit de reconnaissance. Nous lisons l'architecture intérieure et permettons à l'être d'habiter sa présence avec élégance.</p>
                    </div>
                    <div className="detail-block detail-block--right">
                        <span className="detail-tag">Notre approche</span>
                        <p>Nous travaillons par observation fine, par silence et par écoute. Chaque intervention est sur mesure, confidentielle et conçue pour libérer la forme la plus pure de votre présence.</p>
                    </div>
                </section>

                <section id="contact" className="aboutus-cta">
                    <div>
                        <span className="eyebrow eyebrow--light">Contact</span>
                        <h2>Échangeons sur votre révélation.</h2>
                        <p>Si vous cherchez une présence qui parle plus fort que les mots, écrivez-nous. La Maison est ouverte aux personnes qui veulent incarner leur vérité.</p>
                    </div>
                    <a className="button button--primary" href="mailto:contact@hart-elegance.com">contact@hart-elegance.com</a>
                </section>
            </div>
        </div>
    );
};

export default AboutUs;
